export default __webpack_public_path__ + "static/media/traffic.bf464f87.jpg";